import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { take, takeUntil } from "rxjs/operators";
import { CheckBrachAccessModel } from "src/app/gnr/data-center-process/chek-branch-access.model";
import { MeasurementUnitFormComponent } from "../MeasurementUnit-form/MeasurementUnit-form.component";

@Component({
  selector: "ngx-unit-list",
  templateUrl: "./MeasurementUnit-list.component.html",
  styleUrls: ["./MeasurementUnit-list.component.scss"],
})
export class MeasurementUnitListComponent extends BaseListComponent {
  constructor() {
    super();
    this.inputEditorform = MeasurementUnitFormComponent;
  }
  ngOnInit() {
    this.apiName = "MeasurementUnit";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.BackOffice.INV.Unit.UnitList");
  }
  IgnoreDelete: boolean = false;
  deleteMessage: string = "";
  async FillData() {
    const currentInformation = this.accountService.authService.currentInformation();
    if (currentInformation.BranchingLightEnabled || currentInformation.BranchingAdvancedEnabled) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch" + "/Unit")
        .pipe(take(1))
        .subscribe((hbc: CheckBrachAccessModel) => {
          if (hbc.TransferKindCode != 3) {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.IgnoreDelete = true;
              this.deleteMessage = this.translate("ClientApp.FrontOffice.MeasurementUnit.HasBranchCommunication");
              return;
            } else {
              if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
                this.IgnoreDelete = true;
                this.deleteMessage = this.translate("ClientApp.FrontOffice.MeasurementUnit.HasCallCenterCommunication");
                return;
              }
            }
          }
        });
    }
  }
}
